// import React from 'react';

// export const NRLogo = ({ color = '#1e2a54', size = 40 }) => {
//   return (
//     <div className="flex items-center justify-center ml-3">
//       <svg
//         width={size}
//         height={size}
//         viewBox="0 0 200 200"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         {/* Rounded Rectangle Border */}
//         <rect 
//           x="5" 
//           y="5" 
//           width="190" 
//           height="190" 
//           rx="25" 
//           stroke={color} 
//           strokeWidth="10" 
//           fill="none" 
//         />

//         {/* Stylized N */}
//         <path 
//           d="M40 150 L80 50 L80 150" 
//           stroke={color} 
//           strokeWidth="12" 
//           strokeLinecap="round" 
//         />

//         {/* Stylized R */}
//         <path 
//           d="M110 150 V50 H140 Q160 50 160 80 Q160 100 140 100 H110 M140 100 Q170 100 160 150" 
//           stroke={color} 
//           strokeWidth="12" 
//           strokeLinecap="round" 
//           fill="none"
//         />
//       </svg>
//     </div>
//   );
// };


import React from 'react';


export const NRLogo = ({ className="",color = '#1e2a54', size = 50 }) => {
  return (
    <div className="flex items-center justify-center ml-3 ">
<svg
    
    className={className}
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Rounded rectangle border */}
    {/* <rect
      x="5"
      y="5"
      width="190"
      height="190"
      rx="25"
      stroke="#B8ADA8"
      strokeWidth="5"
      fill="none"
    /> */}

    {/* Embedded image */}
    <image
      href={"https://ik.imagekit.io/j78bbzr9d/nr3.png"}
      x="10"
      y="10"
      width="180"
      height="180"
      preserveAspectRatio="xMidYMid meet"
      clipPath="url(#clip-rounded)"

    />

    {/* Optional: Define clipping path to match rounded rectangle */}
    {/* <defs>
      <clipPath id="clip-rounded">
        <rect x="10" y="10" width="190" height="190" rx="20" />
      </clipPath>
    </defs> */}
  </svg>










    </div>
  );
};









// <svg
//   width={size}
//   height={size}
//   viewBox="0 0 200 200"
//   fill="none"
//   xmlns="http://www.w3.org/2000/svg"
// >
//    Rounded rectangle border 
//   <rect
//     x="5"
//     y="5"
//     width="190"
//     height="190"
//     rx="25"
//     stroke={color}
//     strokeWidth="5"
//     fill="none"
//   />

//    Stylized N 
//   <path
//     d="M50 150 V50 L100 150 V50"
//     stroke={color}
//     strokeWidth="12"
//     strokeLinecap="round"
//     fill="none"
//   />

//    Stylized R 
//   <path
//     d="M120 150 V50 H150 C165 50 165 80 150 90 C165 100 170 130 140 130 H120"
//     stroke={color}
//     strokeWidth="12"
//     strokeLinecap="round"
//     fill="none"
//   />
// </svg>
